import pkg from '../../package.json';

const FEEDBACK_TO = 'lucky@chancey.io';

export function buildFeedbackMailto(userId?: string | null): string {
  const subject = `Chancey feedback — v${pkg.version}`;
  const body = [
    '',
    '',
    '',
    '',
    '---',
    `App version: ${pkg.version}`,
    `User ID: ${userId ?? 'anonymous'}`,
    `User agent: ${typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown'}`,
    `Sent: ${new Date().toISOString()}`,
  ].join('\n');
  return `mailto:${FEEDBACK_TO}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function openFeedback(userId?: string | null): void {
  // window.location.href opens the system mail composer more reliably than
  // window.open inside iOS WKWebView / Capacitor.
  window.location.href = buildFeedbackMailto(userId);
}
